module.exports = __webpack_public_path__ + "static/media/50.386748c8.png";